/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/artikel-aktionen-stage/shop.artikel-aktionen-stage.component.ts.
 */
import {ChangeDetectionStrategy, Component, Input, OnDestroy, SimpleChanges} from '@angular/core';
import {Artikel} from '../../../../models/artikel';
import {View} from '../../../../models/view';
import {BehaviorSubject, Subject} from 'rxjs';
import {ArtikelAktion} from '../../../../models/artikel-aktion';
import {ShopViewComponent} from '../view/shop.view.component';
import {takeUntil} from 'rxjs/operators';
import {AppMobileService} from '../../../../services/app.mobile.service';
import {AppArtikelAktionenService} from '../../../../services/app.artikel-aktionen.service';

/**
 * Zweck: Beschreibt class ShopArtikelAktionenStageComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // tslint:disable-next-line:component-selector
    selector: 'artikel-aktionen-stage',
    templateUrl: 'shop.artikel-aktionen-stage.component.html',
    styleUrls: ['shop.artikel-aktionen-stage.component.scss'],
    standalone: false
})
export class ShopArtikelAktionenStageComponent implements OnDestroy {
  @Input() artikel: Artikel;
  @Input() view: View;
  @Input() viewcomp: ShopViewComponent;
  @Input() stage = 1;

  aktion: BehaviorSubject<ArtikelAktion> = new BehaviorSubject<ArtikelAktion>(null);

  _onDestroy = new Subject<void>();

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public msvc: AppMobileService, private artikelAktionenService: AppArtikelAktionenService) {
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.artikelAktionenService.unregisterListener(this.artikel);
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    if (!this.artikel.view) {
      this.artikel.view = this.view;
    }
    this.artikelAktionenService.registerListener(this.artikel).pipe(takeUntil(this._onDestroy)).subscribe({
      next: (a) => {
        if (a && a.length >= this.stage) {
          this.aktion.next(a[this.stage - 1]);
        }
      }
    });
  }
}
